"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var constants_1 = require("containers/App/constants");
var other_1 = require("utils/selectors/other");
var InviteUserModal_1 = __importDefault(require("../InviteUserModal"));
var MenuGroup_1 = __importDefault(require("./MenuGroup"));
var SettingsMenuItem_1 = __importDefault(require("./styles/SettingsMenuItem"));
var PersonalSettings = function (_a) {
    var onClick = _a.onClick;
    var canAdmin = (0, react_redux_1.useSelector)((0, other_1.makeSelectUserCan)(interfaces_1.ACCESS_LEVEL.Admin));
    var _b = __read(react_1.default.useState(false), 2), isInviteUserOpen = _b[0], setIsInviteUserOpen = _b[1];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MenuGroup_1.default, { categoryLabel: "Personal settings", menuItems: constants_1.MENU_PERSONAL_SETTINGS, onCloseDropdown: onClick }), !canAdmin && ((0, jsx_runtime_1.jsx)(SettingsMenuItem_1.default, { onCloseDropdown: onClick, label: "Invite User", onClick: function () { return setIsInviteUserOpen(true); } })), isInviteUserOpen && (0, jsx_runtime_1.jsx)(InviteUserModal_1.default, { open: true, onClose: function () { return setIsInviteUserOpen(false); } })] }));
};
exports.default = PersonalSettings;
